module.exports = __webpack_public_path__ + "img/rightthigh-endomorph-female.61618ed6.svg";